import {
  StatusIcon,
  PriorityIcon,
  PhaseIcon,
  TagsIcon,
  ErrorIcon,
  InterfaceIcon,
  LaunchPadIcon,
} from "allIcons";
import { compact } from "helpers";

export default function getGeneralMenu({ delete_site }) {
  const { search } = window.location;
  const generalMenu = [
    // search &&{
    //   module: "general-settings",
    //   title: "siteTemplate.menu.general",
    //   icon: <SiteIcon />,
    // },
    {
      module: "interface",
      title: "siteTemplate.menu.interface",
      icon: <InterfaceIcon />,
    },
    {
      module: "launchpad-widgets",
      title: "siteTemplate.menu.launchpadWidgets",
      icon: <LaunchPadIcon />,
    },
    {
      module: "phases",
      title: "siteTemplate.menu.phases",
      icon: <PhaseIcon />,
    },
    {
      module: "status",
      title: "siteTemplate.menu.status",
      icon: <StatusIcon />,
    },
    {
      module: "priority",
      title: "siteTemplate.menu.priority",
      icon: <PriorityIcon />,
    },
    {
      module: "tags",
      title: "siteTemplate.menu.tags",
      icon: <TagsIcon />,
    },
    search &&
      delete_site && {
        module: "advanced",
        title: "siteTemplate.menu.advanced",
        icon: <ErrorIcon />,
      },
  ];

  return compact(generalMenu);
}
